import moment from 'moment';

export function vRequired(msg) {
  return v => {
    return (
      v === '0' || v === [] || v === true || v !== '' || msg || 'Kötelező mező'
    );
  };
}
export function vMaxLength(n, msg) {
  return v => {
    return (
      !v ||
      (v || '').length <= n ||
      msg ||
      `A maximális karakterszám ${n} lehet`
    );
  };
}
export function vMinLength(n, msg) {
  return v => {
    return (
      !v ||
      (v || '').length >= n ||
      msg ||
      `A minimális karakterszám ${n} lehet`
    );
  };
}
export function vMinNumber(n, msg) {
  return v => {
    let num = parseFloat((v + '').replace(/ /g, ''));
    return (
      (!isNaN(num) && num >= n) ||
      (msg + '').replace('_N_', n) ||
      `A szám értéke minimum ${n} lehet`
    );
  };
}
export function vMaxNumber(n, msg) {
  return v => {
    let num = parseFloat((v + '').replace(/ /g, ''));
    return (
      (!isNaN(num) && num <= n) ||
      (msg + '').replace('_N_', n) ||
      `A szám értéke maximum ${n} lehet`
    );
  };
}
export function vGtNumber(n, msg) {
  return v => {
    let num = parseFloat(v);
    return (
      (!isNaN(num) && num > n) ||
      msg ||
      `A számnak nagyobbnak kell lennie, mint  ${n}`
    );
  };
}
export function vLtNumber(n, msg) {
  return v => {
    let num = parseFloat(v);
    return (
      (!isNaN(num) && num < n) ||
      msg ||
      `A számnak kisebbnek kell lennie, mint  ${n}`
    );
  };
}
export function vGtDate(n, msg) {
  return v => {
    let date = moment(v);
    let dateParam = moment(n);
    if (!v || !date.isValid()) return 'Dátum hiba';

    return (
      date.isSameOrAfter(dateParam) || msg || 'Csak későbbi dátum adható meg'
    );
  };
}

export function vLtDate(n, msg) {
  return v => {
    let date = moment(v);
    let dateParam = moment(n);
    if (!v || !date.isValid()) return 'Dátum hiba';
    return (
      date.isSameOrBefore(dateParam) || msg || 'Csak korábbi dátum adható meg'
    );
  };
}
export function vDateIsvalid(msg) {
  return v => {
    let date = moment(v);
    if (!v || !date.isValid()) return 'Dátum hiba';
    return true || msg || 'Nem valós dátum';
  };
}
export function vEmail(msg) {
  return v => {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(v).toLowerCase()) || msg || 'Hibás email formátum';
  };
}
export function vTelephone(msg) {
  return v => {
    const re = /^\+36\d{7,}$/;
    return (
      re.test(String(v).toLowerCase()) ||
      msg ||
      'Hibás telefonszám (+123456789)'
    );
  };
}
export function vSameValue(otherValue, msg) {
  return v => {
    return (v || '') == (otherValue || '') || msg || 'A jelszavak nem egyeznek';
  };
}
export function vMinEletkor(n, msg) {
  return v => {
    let date = moment(v);
    let dateNow = moment();

    if (!v || !date.isValid()) return 'Dátum hiba';
    let minDate = dateNow.subtract({ years: n });
    return (
      minDate.isSameOrAfter(date) ||
      msg ||
      `${n} évnél fiatalabb nem regisztrálhat`
    );
  };
}
export function vNumberOnly(msg) {
  let re = /^([0-9])+$/;
  return v => {
    if (!v) {
      return true;
    }
    return re.test(v + '') || msg || 'Csak szám adható meg';
  };
}
export function vNumberLetterSpaceOnly(msg) {
  let re = /^([a-zA-Z0-9\u00C0-\u017F]| |\.|-)+$/;
  return v => {
    return re.test(v + '') || msg || 'Csak betű, szám és szóköz adható meg';
  };
}
export async function scrollToError(vm) {
  await vm.$nextTick();
  var element = vm.$el.querySelector('.v-form .error--text');
  if (element) {
    element.scrollIntoView({ block: 'center', behavior: 'smooth' });
  }
}
